import gql from 'graphql-tag';
import * as Urql from 'urql';

import * as Types from './types';

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetTemperaturesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetTemperaturesQuery = { __typename?: 'query_root', container_insights_temperatures: Array<{ __typename?: 'container_insights_temperatures', id: any, label: string, min?: any | null, max?: any | null, created_at: any, updated_at: any }> };


export const GetTemperaturesDocument = gql`
    query GetTemperatures {
  container_insights_temperatures {
    id
    label
    min
    max
    created_at
    updated_at
  }
    }
`;

export function useGetTemperaturesQuery(
  options?: Omit<Urql.UseQueryArgs<GetTemperaturesQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GetTemperaturesQuery, GetTemperaturesQueryVariables>({
    query: GetTemperaturesDocument,
    ...options,
  });
}
